import { m } from 'motion/react';
import { itemVariants } from '../../../utils/framer';
import ImgCarousel from '../../components/behindTheSceens/ImgCarousel';
import YouTubeEmbed from '../../components/behindTheSceens/YouTubeEmbed';
import AnimatedSection from '../../components/privatleasing/AnimatedSection';
import HeroPrivatLeasing from '../../components/privatleasing/HeroPrivatLeasing';
import { TwoFlexibleComponentBox } from '../../components/rentAndShare/TwoFlexibleComponentBox';
import Snippet from '../../components/Snippet';
import KIAImage from '../../components/ui/image/KIAImage';
import LinkButton from '../../components/ui/LinkButton';
import {
  herobts,
  images,
  kiaImagebts03,
  kiaImagebts04,
  linkbts03,
  linkbts04,
  subheadingbts,
  twoComponentsTextbts01,
  twoComponentsTextbts02,
  twoComponentsTextbts03,
  twoComponentsTextbts04,
} from './behindTheSceeens-copy';

const BehindTheSceens = () => {
  return (
    <main className="relative">
      <HeroPrivatLeasing {...herobts} />
      <div className="w-full max-w-screen-kia mx-auto">
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-8">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-5"
            secondComponentWidth="col-span-4 lg:col-span-3"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={
              <YouTubeEmbed videoId="FLN6OG94SZc" width="100%" height="356px" />
            }
            secondComponent={
              <div className="mb-10 md:mb-0">
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextbts01.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextbts01.text}
                </p>
              </div>
            }
          />
        </section>
        <section className=" mx-auto px-6 w-full max-w-7xl mb-20 md:mb-28">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-3"
            secondComponentWidth="col-span-4 lg:col-span-5"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0 "
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent={
              <div className="mb-10 md:mb-0">
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextbts02.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextbts02.text}
                </p>
              </div>
            }
            secondComponent={
              <YouTubeEmbed videoId="b1XTh6x2yPA" width="100%" height="356px" />
            }
          />
        </section>

        <section className=" mx-auto px-6 w-full  max-w-7xl mb-8">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-5"
            secondComponentWidth="col-span-4 lg:col-span-3"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0"
            secondComponentClassName="p-0 lg:p-10 lg:pt-0"
            mobilFirstComponentOnTop={false}
            desktopFirstComponentFirst={true}
            firstComponent={<KIAImage {...kiaImagebts03} />}
            secondComponent={
              <div>
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextbts03.title}
                </h3>
                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextbts03.text}
                </p>
                <div className="flex justify-center md:justify-start">
                  <LinkButton {...linkbts03} />
                </div>
              </div>
            }
          />
        </section>
        <section className=" mx-auto px-6 w-full  max-w-7xl mb-5">
          <TwoFlexibleComponentBox
            firstComponentWidth="col-span-4 lg:col-span-3"
            secondComponentWidth="col-span-4 lg:col-span-5"
            mainBoxClassName="mx-auto w-full max-w-7xl"
            firstComponentClassName="p-0 lg:p-10 lg:pt-0"
            secondComponentClassName="p-0"
            mobilFirstComponentOnTop={true}
            desktopFirstComponentFirst={true}
            firstComponent ={
              <div>
                <h3 className="text-[23px] md:text-[32px] leading-[40px] mb-4">
                  {twoComponentsTextbts04.title}
                </h3>

                <p className="text-[16px] md:text[18px] leading-[24px] font-light">
                  {twoComponentsTextbts04.text}
                </p>

                <div className="flex justify-center md:justify-start">
                  <LinkButton {...linkbts04} />
                </div>
              </div>
            }
            secondComponent={<KIAImage {...kiaImagebts04} />}
          />
        </section>
       
        <section className=" mx-auto px-6 w-full max-w-7xl mt-10 md:mt-28">
          <AnimatedSection id="subhedings" className="mb-1">
            <m.h2
              className="text-[23px] md:text-[32px] leading-[40px] mb-4"
              variants={itemVariants}
            >
              {subheadingbts.heading}
            </m.h2>
          </AnimatedSection>
          <ImgCarousel images={images} />
        </section>

        <Snippet page="behind-the-sceens" />
      </div>
    </main>
  );
};

export default BehindTheSceens;
